<app-table [data]="tools"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [title]="title"
           [hasTitle]="hasTitle"
           [isMaterial]="isMaterial"
           [saveFilters]="true"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column
        [header]="'lift-operator.incoming-tools-table.createdAt' | translate"
        field="createdDate">
        <ng-template #body
                     let-toolRequest="rowData">
            <span>{{ toolRequest.createdDate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column *ngIf="this.requestType==='LINE'"
                      [header]="'lift-operator.incoming-tools-table.manufactureLine' | translate"
                      [filterPlaceholder]="'lift-operator.incoming-tools-table.byLine' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="line">
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.line?.name }}</span>
        </ng-template>
    </app-table-column>

    <app-table-column [header]="'lift-operator.incoming-tools-table.mainToolLines' | translate"
                      [sortable]="false"
                      field="mainToolLines">
        <ng-template #body
                     let-ticket="rowData">
            <span> {{ ticket.mainToolLines }}</span>
        </ng-template>
    </app-table-column>

    <app-table-column *ngIf="this.requestType==='TICKET'"
                      [header]="'lift-operator.incoming-tools-table.facility' | translate"
                      [filterPlaceholder]="'lift-operator.incoming-tools-table.byFacility' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="facility">
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.facility?.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column *ngIf="this.requestType==='LINE' && this.section ==='REQUESTS'"
                      header="{{'atom.tool-requests-lines.table.columns.type' | translate}}"
                      field="type"
                      [sortable]="false">
        <ng-template #body let-toolRequest="rowData">
            <span>    {{ 'atom.tool-requests-lines.table.type.' + toolRequest.type | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column [header]="'lift-operator.incoming-tools-table.status' | translate"
                      [filterPlaceholder]="'lift-operator.incoming-tools-table.byStatus' | translate"
                      sortable="true"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterStatusList"
                          valueField="value"
                          displayField="name"
                          emptyText="Status"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column cls="last-column"
                      [header]="'lift-operator.incoming-tools-table.actions' | translate">
        <ng-template #body
                     let-tool="rowData">
            <app-button
                type="primary"
                *ngIf="tool.status === 'Approved'"
                class="process-button"
                (click)=onProcess(tool)>
                {{ "lift-operator.incoming-tools-table.process" | translate | uppercase }}
            </app-button>
            <app-button
                type="warning"
                *ngIf="tool.status === 'WaitingForProcessing'"
                class="process-button"
                (click)=resumeProcess(tool)>
                {{ "lift-operator.incoming-tools-table.resumeProcess" | translate | uppercase }}
            </app-button>
            <app-tooltip *ngIf="tool.highPriority" type="info"
                         record="{{'atom.tool-returns.table.columns.orderedPriority' | translate}}">
            </app-tooltip>
        </ng-template>
    </app-table-column>
</app-table>
